import React,{useState} from 'react';
import RegistarCliente from './RegistarCliente';
import '../ClienteRegis.css';
import axios from 'axios';
import {toast,ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
function ClienteRegistro() {
    const [registarClinte,setRegistro]=useState(null);
    const [importClient,setImport]=useState(null);
    const[state,setState]=useState();

    const HandleRegis=()=>{
        setImport(null);
        setRegistro("sds")
    }
    const HandleImport=()=>{
      setRegistro(null);
      setImport("sdsd");
    
    }
    const formdata=new FormData();

const Uploadfile=()=>{
  formdata.append('media',state.File);
  axios({
      method:"post",
      url:`${localStorage.getItem('url')}/web/exportclient/`,
      headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
      data:formdata
  }).then(dat=>{ if(dat.status!==200){
      throw Error('Dados de acesso invalidos');  
          }
      return dat
   } ).then( d=>{
    toast.success("Contadores importados com Sucesso!");
  }
 
     ).catch(e=>{
      toast.error("O contador Ja foi registrado!")
     })


  }
  const handleFile=(e)=>{
    let file=e.target.files[0]
    setState({File:file});
  }

  return (
    <div className='importars'>  
     <button  id="opcao" value="Nao" onClick={HandleImport}>Importar Clientes</button>
    {registarClinte && <RegistarCliente/>}
    {importClient && <div className='importarClientess'>
                <input id="inpu" type="file" name="file" accept='.xls,.xlsx' onChange={(e)=>handleFile(e)} />
                <button  id="opcao" value="Nao" onClick={Uploadfile}>Importar</button>
              </div>}
  </div>
  )
}

export default ClienteRegistro